import React from 'react'
import Terms from 'src/app/Terms/Terms'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { termsRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const TermsAppRoute: AppRoute = {
  id: AppLocation.Terms,
  routeProps: termsRouteProps,
  component: <Terms />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default TermsAppRoute
